<div class="container-fluid csat-wrapper">
    <div class="rate-us">
        <h1 style="font-weight: 500"> Rate us! </h1>
        <p> How was stay the past month. It would help us serve you better. </p>
    </div>    
    <form role="form">
        <div class="csat-icon-wrapper"  >
            <fa-icon [icon]="faAngry" class="csat-icons hoverVPoor" (click) = "selectFeedbackRate(1)" [ngClass] = "csat.rating == 1 ? 'vPoor' : 'selectedRate' " ></fa-icon>
            <fa-icon [icon]="faFrown"  class="csat-icons hoverPoor" (click)="selectFeedbackRate(2)" [ngClass] = "csat.rating == 2 ? 'poor' : 'selectedRate' "></fa-icon>
            <fa-icon [icon]="faSmile"  class="csat-icons hoverFair" (click)="selectFeedbackRate(3)" [ngClass] = "csat.rating == 3 ? 'fair' : 'selectedRate' "></fa-icon>
            <fa-icon [icon]="faSmileBeam"  class="csat-icons hoverGood" (click)="selectFeedbackRate(4)" [ngClass] = "csat.rating == 4 ? 'good' : 'selectedRate' "></fa-icon>
            <fa-icon [icon]="faLaughBeam"  class="csat-icons hoverBest" (click)="selectFeedbackRate(5)" [ngClass] = "csat.rating == 5 ? 'best' : 'selectedRate' "></fa-icon>
        </div>
        <div style="display: flex; justify-content: center; margin: 20px 0px;">
            <textarea class="form-control col-md-4 col-lg-4 col-sm-12 col-xs-12" name="comment" placeholder="Remarks" [ngModel] = "csat.comment"  (ngModelChange)="changeComment($event)"></textarea>            
        </div>
        <div style="text-align: center; margin: 20px 0px ;">
            <button class="btn btn-primary" type="submit" (click)="submitForm()"> Send Feedback </button>
        </div>        
    </form>       
        
    <div class="form_sub_msg" *ngIf="form_msg == true">
        <p> {{ form_submit_msg }} </p>
    </div>
    <div class="form_err_msg" *ngIf="form_err_msg == true">
        <p> {{ form_submit_msg }} </p>
    </div>
    
</div>